import { render, staticRenderFns } from "./child5.vue?vue&type=template&id=508a8b38&"
import script from "./child5.vue?vue&type=script&lang=js&"
export * from "./child5.vue?vue&type=script&lang=js&"
import style0 from "./child5.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports